/**
 * Nearby Vuex
 */

import * as API from '@/endpoints'
import Utils from '@/utils.js'
import Axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    showDonate: false,
    processingDonation: false
  },
  mutations: {
    setShowDonate (state, v) {
      Vue.set(state, 'showDonate', v)
    },
    setProcessingDonation (state, v) {
      Vue.set(state, 'processingDonation', v)
    }
  },
  actions: {
    payWithPaypal ({commit, dispatch, state}, payload) {
      // {
      // 	"card": {
      // 		"number": "4242424242424242",
      // 		"number": "371722835312000",
      // 		"expire_year": "2025",
      // 		"expire_month": "05",
      // 		"pin": "565"
      // 	},
      // 	"amount": 500,
      // 	"item_id": "1"
      // }

      payload.item_id = (payload && "app_id" in payload) ? payload.item_id : Cons[0].BRAND_ID;
      delete payload.items;
      delete payload.card.first_name;
      delete payload.card.last_name;
      delete payload.description;
      console.log("DONATE", payload)

      commit('setProcessingDonation', true)
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.stripe, payload).then(
          res => {
            console.log(res.data)
            commit('setProcessingDonation', false)
            resolve(res.data)
          },
          error => {
            commit('setProcessingDonation', false)
            // dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    }
  }
}
